jQuery(document).ready(function ($) {
    $.fn.getAnswersToEdit = function () {
        if (this.next().length > 0) {
            this.next().remove();
            return;
        }

        const question = this.attr('data-question-id');

        const _this = this;

        dataLayer.push({
            event: 'editing_answer'
        });

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                question: question,

                action: 'arise_pc_edit_answer',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                _this.closest('.pricing-calculator__results').addClass('loading');
            },

            success: function (response) {
                _this.closest('.pricing-calculator__results').removeClass('loading');

                const $panel = $(response.data.answers);
                $panel.insertAfter(_this);

                if (response.data.current_selection !== null && response.data.current_selection !== '') {
                    const selectedIndices = String(response.data.current_selection).split(',').map(Number);
                    $panel.find('.pricing-calculator__answer').each(function (i) {
                        if (selectedIndices.includes(i)) {
                            $(this).addClass('selected');
                        }
                    });
                }

                $panel.find('.pricing-calculator__change--container').append(
                    '<button class="pc-confirm-edit" type="button">Confirm selection</button>'
                );
            },

            complete: function () {
                _this.closest('.pricing-calculator__results').removeClass('loading');
            }
        });
    }

    $.fn.submitSelectedAnswers = function () {
        const $change = this.closest('.pricing-calculator__change');
        const question = $change.prev().attr('data-question-id');
        const selectedIndices = [];

        $change.find('.pricing-calculator__answer.selected').each(function () {
            selectedIndices.push($(this).index());
        });

        if (selectedIndices.length === 0) return;

        const response = question + ':' + selectedIndices.join(',');

        const _this = this;

        dataLayer.push({
            event: 'submitting_changed_answer',
            answer_name: $change.find('.pricing-calculator__answer.selected').map(function () {
                return $(this).find('span').text();
            }).get().join(', ')
        });

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                response: response,

                action: 'arise_pc_submit_new_answer',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                _this.closest('.pricing-calculator__results').addClass('loading');
            },

            success: function (response) {
                _this.closest('.pricing-calculator__results').removeClass('loading');

                const results = _this.closest('.pricing-calculator__results');
                $(response.data.results).insertAfter(results).show();
                results.remove();
            },

            complete: function () {
                _this.closest('.pricing-calculator__results').removeClass('loading');
            }
        });
    }

    $(document).on('click', '.pc-edit', function (event) {
        event.preventDefault();

        $(this).getAnswersToEdit();
    });

    $(document).on('click', '.pricing-calculator__change .pc-confirm-edit', function (event) {
        $(this).submitSelectedAnswers();
    });
});
